import React, { Component } from "react";
import ListingPage from "../Controls/ListingPage";
import Window from "../Controls/Window";
import AddEditPaymentTypes from "../../Settings/AddEditPaymentTypes";

class PaymentTypeList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,
      page: 1,
      pageSize: 25,

      showDelete: false,
      showAddModuleConfiguration: false,
      selectedRow: null,

      listPageSettings: {

        Title: "Payment Types",

        Search: {
          showSearch: false,
        },

        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          }
        ],

        Columns: [
          {
            Name: "Payment Type",
            Type: "field",
            Columns: [{ Column: "PaymentType" }],
          },
          {
            Name: "Sequence",
            Type: "field",
            Columns: [{ Column: "SequenceNo" }],
          },
          {
            Name: "",
            Type: "multiple",
            Columns: [
              { Column: "ShowInSales", Type: "yesno", Label: "Show in sales" },
              {
                Column: "ShowInExpense",
                Type: "yesno",
                Label: "Show in expense",
              },
            ],
          },
          {
            Name: "",
            Type: "multiple",
            ShowInMobile: true,
            Columns: [
              { Column: "PaymentType" },
              { Column: "SequenceNo", Label: "Sequence" },
              { Column: "ShowInSales", Type: "yesno", Label: "Show in sales" },
              {
                Column: "ShowInExpense",
                Type: "yesno",
                Label: "Show in expense",
              },
            ],
          },
        ],

        RowButtons: [
          {
            ButtonType: "ImageButton",
            Type: "edit",
            Text: "Edit",
            Icon: "edit"
          },
          {
            ButtonType: "ImageButton",
            Type: "delete",
            Text: "Delete",
            Icon: "delete"
          }
        ]
      }
    };
  }

  componentDidMount() {
    this.loadData();
  }

  // =====================
  // LOAD DATA
  // =====================

  loadData = async () => {

    this.setState({ loading: true });

    try {

      await this.props.getPaymentTypes(
        this.props.user.user.RegistrationID
      );

      let paymenttypes =
        this.props.config.PaymentTypes.filter(
          (e) => !e.IsDeleted
        );

      this.setState({
        list: paymenttypes,
        totalCount: paymenttypes.length,
        loading: false,
      });

    } catch (error) {

      console.error(error);

      this.setState({ loading: false });

      this.props.getToastr(
        "Failed to fetch payment type"
      );

    }
  };

  // =====================
  // PAGINATION
  // =====================

  onNextClick = () => {

    const totalPages =
      Math.ceil(
        this.state.totalCount /
        this.state.pageSize
      );

    if (this.state.page < totalPages) {

      this.setState({
        page: this.state.page + 1
      });

    }

  };

  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState({
        page: this.state.page - 1
      });

    }

  };

  onFirstClick = () => {

    this.setState({
      page: 1
    });

  };

  onLastClick = () => {

    const totalPages =
      Math.ceil(
        this.state.totalCount /
        this.state.pageSize
      );

    this.setState({
      page: totalPages
    });

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState({
      pageSize: Number(size),
      page: 1
    });

  };

  // =====================
  // HEADER BUTTON
  // =====================

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new") {

      this.setState({
        showAddModuleConfiguration: true,
        selectedRow: null
      });

    }

  };

  // =====================
  // ROW BUTTON
  // =====================

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "edit") {

      this.setState({
        showAddModuleConfiguration: true,
        selectedRow: row
      });

    }

    if (btn.Type === "delete") {

      this.setState({
        showDelete: true,
        selectedRow: row
      });

    }

  };

  // =====================
  // DELETE
  // =====================

  deleteRecord = async () => {

    try {

      this.setState({
        loading: true,
        showDelete: false
      });

      await this.props.deletePaymentType(
        this.state.selectedRow.key
      );

      this.props.getToastr(
        "Payment type deleted successfully"
      );

      this.setState({
        selectedRow: null,
        loading: false
      });

      this.loadData();

    } catch (error) {

      console.error(error);

      this.setState({
        loading: false,
        selectedRow: null
      });

      this.props.getToastr(
        "Failed to delete payment type"
      );

    }

  };

  // =====================
  // POPUP
  // =====================

  onClosePopup = () => {

    this.setState({
      showAddModuleConfiguration: false,
      selectedRow: null
    });

  };

  onPostPopupSave = () => {

    this.setState({
      showAddModuleConfiguration: false,
      selectedRow: null
    });

    this.loadData();

  };

  // =====================
  // PAGINATED DATA
  // =====================

  getPagedList = () => {

    const start =
      (this.state.page - 1)
      * this.state.pageSize;

    const end =
      start + this.state.pageSize;

    return this.state.list.slice(start, end);

  };

  // =====================
  // RENDER
  // =====================
  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

  render() {

    return (

      <>

        <ListingPage

          {...this.props}

          listPageSettings={{
            ...this.state.listPageSettings
          }}
          onPageChange={this.onPageChange}

          list={this.getPagedList()}

          loading={this.state.loading}

          totalItemsCount={
            this.state.totalCount
          }

          recordFrom={
            (this.state.page - 1)
            * this.state.pageSize
          }

          itemsCountPerPage={
            this.state.pageSize
          }

          onNextClick={this.onNextClick}

          onPreviousClick={
            this.onPreviousClick
          }

          onFirstClick={
            this.onFirstClick
          }

          onLastClick={
            this.onLastClick
          }

          onRecordsPerPageCountChange={
            this.onRecordsPerPageCountChange
          }

          onHeaderButtonClicked={
            this.onHeaderButtonClicked
          }

          onRowButtonClicked={
            this.onRowButtonClicked
          }

        />

        {/* DELETE */}

        {this.state.showDelete && (

          <Window

            header="Delete"

            modal

            onClose={() =>
              this.setState({
                showDelete: false
              })
            }

            onButtonClick={(btn) => {

              if (btn === "Yes")
                this.deleteRecord();

              else
                this.setState({
                  showDelete: false
                });

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }
            ]}

          >

            Are you sure you want to delete?

          </Window>

        )}

        {/* ADD / EDIT */}

        {this.state.showAddModuleConfiguration && (

          <AddEditPaymentTypes

            {...this.props}

            paymentType={
              this.state.selectedRow
            }

            onSave={() =>
              this.onPostPopupSave()
            }

            onClose={() =>
              this.onClosePopup()
            }

          />

        )}

      </>

    );

  }

}

export default PaymentTypeList;